import {b}from'./chunk-BVQ42ESU.js';var [o,n]=b();export{o as a,n as b};